var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"img"},[_c('img',{attrs:{"src":_vm.urlToLineImage}}),(_vm.isTramOrBus)?_c('div',{staticClass:"img-text",class:_vm.imgTextClass},[_vm._v(_vm._s(_vm.lineName))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }